module.exports = __webpack_public_path__ + "img/settings.7c44f494.png";